import "../css/Login.css";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/img/ThinkStore_Logo.png";

const SuccessfulReset = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <div className="login-left"></div>

      <div className="login-right d-flex flex-column justify-content-center align-items-start w-100">
        {/* Fixed Logo */}
        <div className="mx-auto">
          <img
            src={Logo}
            className="w-80 aspect-[4/1] object-contain"
            alt="Logo"
          />
        </div>

        <div className="mx-auto text-center mt-4 p-4">
          {/* Success Icon */}
          <div className="mb-4 d-flex justify-center">
            <img
              src="/asset/Successfully.png"
              alt="Success"
              style={{ height: "80px" }}
            />
          </div>

          {/* Message */}
          <h4 className="fw-bold">Successfully</h4>
          <p className="text-muted small">
            Your Password has been successfully Reset..
          </p>

          {/* Button */}
          <button
            className="btn custom-btn mt-3 w-100 fw-bold text-white p-2 "
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          >
            Back to login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessfulReset;
